import React from 'react'

type Props = {
  className: string
  prefix: string
  title: string
  suffix: string
}

const badges: {[index: string]: React.ReactElement} = {
  sale: (
    <span className="offer sale">
      <i className="icon-receipt-tax" />
      SALE
    </span>
  ),
  'free-shipping': (
    <span className="offer free-shipping">
      <strong>FREE</strong>SHIPPING
    </span>
  ),
  bogo: (
    <span className="offer bogo">
      <i className="icon-shopping-bag" />
      BOGO
    </span>
  ),
  freebie: <span className="offer freebie">FREEBIE</span>,
  rebate: <span className="offer rebate">REBATE</span>,
  'gift-card': (
    <span className="offer gift-card">
      <strong>GIFT</strong>CARD
    </span>
  ),
}

export const OfferBadge = ({prefix, title, suffix, className = ''}: Props) =>
  badges[className] || (
    <span className={`offer ${className}`}>
      <u>{prefix}</u>
      {title} <b>{suffix}</b>
    </span>
  )
